module.exports = __webpack_public_path__ + "UA.png?b463046fcc08537c676af5e8b20a25b8";